import type { IAppEnvironment } from '@bp/shared/typings';

export const environment: Partial<IAppEnvironment> = {
	api: 'https://signup.bridgerpay.dev',
};
